import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;

export const Button = styled.button`
  background-color: #292828;
  color: white;
  padding: 12px 15px;
  border-radius: 4px;
  border: none;
  &:focus {
    outline: none;
  }
`;
